import { render } from "./MasterWorldMain.vue?vue&type=template&id=72f6b369"
import script from "./MasterWorldMain.vue?vue&type=script&lang=js"
export * from "./MasterWorldMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__